import { createSelector } from 'reselect';

import getCurrentUser from './getCurrentUser';

const getUserId = createSelector(getCurrentUser, user => user?.id);

export default getUserId;
